import styled from 'styled-components';
import {MAIN_COLOR} from "../../components/globalThemes";

export const GroupLink = styled.span`
    font-family: BlenderProBold, serif;
    letter-spacing: 1px;
    color: ${MAIN_COLOR};
    font-size: 25px;
    margin-left: 15px;
    
    @media (max-width: 480px) {
        font-size: 20px;
    }
`;

export const GroupDesc = styled.span`
    font-family: Roboto Condensed, serif;
    margin-left: 15px;
    font-size: 14px;
    font-weight: 300;
    white-space: pre-wrap;
    color: white;
    margin-top: 5px;
    margin-right: 50px;
    
    @media (max-width: 480px) {
        font-size: 10px;
    }
`;

export const DescContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 400px;
`;

export const GroupAd = styled.a`
    height: 200px;
    background-color: #1F1F1F;
    max-width: 600px;
    width: 100%;
    display: flex;
    align-items: center;
    clip-path: polygon(0 0, 100% 0, 85% 100%, 0% 100%);
    cursor: pointer;
    margin-bottom: 30px;
    margin-top: 30px;
    text-decoration: none;
    
    @media (max-width: 480px) {
        max-width: 400px;
        height: 100px;
        margin-top: 0;
    }
`;

export const GroupAdWrapper = styled.div`
    height: 100%;
    width: 100%;
    flex: 1;
    align-items: center;
    display: flex;
    
    @media (max-width: 950px) {
        order: 1;
    }
`;

export const FootballBackground = styled.img`
    position: absolute;
    right: -30px;
    bottom: -30px;
    opacity: 0.2;
    width: 300px;
    height: 300px;
`;

export const SectionSubtitle = styled.p`
    font-family: BlenderProBold, serif;
    font-size: 15px;
    color: black;    
`;
